import { Add16, Close16, Send16 } from "@carbon/icons-react";
import { Col, Spin, Switch } from "antd";
import { formatDate } from "helpers/date-time";
import { EmailRemindConfigFilter } from "models/EmailRemindConfig";
import {
  Button,
  FormItem,
  InputText,
  Select,
  StandardTable,
} from "react3l-ui-library";
import { Row } from "reactstrap";
import { emailRemindConfigRepository } from "repositories/email-remind-config-repository";
import { utilService } from "services/common-services/util-service";
import nameof from "ts-nameof.macro";
import useEmailRemindConfigDetailHook from "./EmailRemindConfigDetailHook";

function EmailRemindConfigDetail() {
  const {
    translate,
    validAction,
    model,
    isDetail,
    handleChangeSingleField,
    handleChangeSelectField,
    handleChangeTemplateCode,
    emailRemindConfigMappingColumns,
    handleAddRow,
    listEmailReminderSchedules,
    handleGoMaster,
    handleSaveModel,
    handleChangeStatus,
    loadingDetail,
  } = useEmailRemindConfigDetailHook();

  return (
    <Spin spinning={loadingDetail}>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-   component ml-4 mb-3">
          <span>{translate("emailRemindConfig.master.header")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("emailRemindConfig.master.subHeader")}
          </span>
        </div>
        <div className="pt-3 pl-3 pb-3 d-flex justify-content-between background-w-dxg border-tl-8-dxg border-bottom">
          <h5 className="font-bold ml-3">
            {!isDetail
              ? translate("general.actions.create")
              : translate("general.detail.title")}
          </h5>
          <div className="mr-3">
            <Button
              type="secondary"
              className="btn--lg btn-red"
              icon={<Close16 />}
              onClick={handleGoMaster}
            >
              {translate("general.actions.close")}
            </Button>
            {/* <Button
              type="secondary"
              className="btn--lg btn-orange-export ml-3"
              icon={<Time16 />}
              onClick={handleGoHistory(model?.id)}
            >
              {translate("general.actions.viewHistory")}
            </Button> */}
            {((!isDetail && validAction("create")) ||
              (isDetail && validAction("update"))) && (
              <Button
                type="primary"
                className="btn--lg btn-blue ml-2"
                icon={<Send16 />}
                onClick={handleSaveModel}
              >
                {translate("general.actions.save")}
              </Button>
            )}
          </div>
        </div>
        <div className="page page-detail border-tl-0-dxg p-t--lg p-l--xxl p-r--xxl p-b--lg">
          <div className="page-detail__title p-b--lg">
            {translate("emailRemindConfig.infoTitle")}
          </div>
          <Row>
            <Col lg={6} className="m-b--xxxs m-t--xxxs">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.code)
                )}
                message={utilService.getValidateMessage(
                  model,
                  nameof(model.code)
                )}
              >
                <InputText
                  isRequired
                  label={translate("emailRemindConfig.code")}
                  type={0}
                  value={model.code?.toString()}
                  placeHolder={translate("emailRemindConfig.placeholder.code")}
                  className={"tio-account_square_outlined"}
                  onChange={handleChangeSingleField({
                    fieldName: nameof(model.code),
                  })}
                />
              </FormItem>
            </Col>
            <Col lg={6} className="m-b--xxxs m-t--xxxs">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.name)
                )}
                message={utilService.getValidateMessage(
                  model,
                  nameof(model.name)
                )}
              >
                <InputText
                  isRequired
                  label={translate("emailRemindConfig.name")}
                  type={0}
                  value={model.name}
                  placeHolder={translate("emailRemindConfig.placeholder.name")}
                  className={"tio-account_square_outlined"}
                  onChange={handleChangeSingleField({
                    fieldName: nameof(model.name),
                  })}
                />
              </FormItem>
            </Col>
            <Col lg={6} className="m-b--xxxs m-t--xxxs">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.applyFunction)
                )}
                message={utilService.getValidateMessage(
                  model,
                  nameof(model.applyFunction)
                )}
              >
                <Select
                  isRequired
                  label={translate("emailRemindConfig.applicableFunction")}
                  type={0}
                  classFilter={EmailRemindConfigFilter}
                  searchProperty={"name"}
                  placeHolder={translate(
                    "emailRemindConfig.placeholder.applicableFunction"
                  )}
                  getList={emailRemindConfigRepository.filter}
                  onChange={handleChangeSelectField({
                    fieldName: nameof(model.applyFunction),
                  })}
                  value={model.applyFunction}
                />
              </FormItem>
            </Col>
            <Col lg={6} className="m-b--xxxs m-t--xxxs">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.statusId)
                )}
                message={model.errors?.statusId}
              >
                <div>
                  <div className={"label-status"}>
                    {translate("emailRemindConfig.status")}
                  </div>
                  <Switch
                    checked={model.statusId === 1 ? true : false}
                    className={"switch_status"}
                    // disabled={view}
                    onChange={handleChangeStatus({
                      fieldName: nameof(model.statusId),
                    })}
                  />
                </div>
              </FormItem>
            </Col>
            <Col lg={12} className="m-b--xxxs m-t--xxxs">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.description)
                )}
                message={model.errors?.description}
              >
                <InputText
                  label={translate("emailRemindConfig.description")}
                  type={0}
                  value={model.description}
                  placeHolder={translate(
                    "emailRemindConfig.placeholder.description"
                  )}
                  className={"tio-account_square_outlined"}
                  onChange={handleChangeSingleField({
                    fieldName: nameof(model.description),
                  })}
                  maxLength={500}
                  showCount
                />
              </FormItem>
            </Col>
            <Col lg={6} className="m-b--xxxs m-t--xxxs">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  "applyFunction.templateCode"
                )}
                message={utilService.getValidateMessage(
                  model,
                  "applyFunction.templateCode"
                )}
              >
                <InputText
                  isRequired
                  label="Template Code"
                  type={0}
                  value={model?.applyFunction?.templateCode ?? ""}
                  placeHolder="Nhập template code"
                  className={"tio-account_square_outlined"}
                  onChange={handleChangeTemplateCode}
                  maxLength={500}
                />
              </FormItem>
            </Col>
            {isDetail && (
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="w-100">
                {/* Người tạo */}
                <Col lg={6} className="m-b--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.createdBy)
                    )}
                    message={model.errors?.createdBy}
                  >
                    <InputText
                      label={translate("emailRemindConfig.createdBy")}
                      type={0}
                      value={model.createdBy?.name}
                      className={"tio-account_square_outlined"}
                      disabled
                    />
                  </FormItem>
                </Col>

                {/* Ngày tạo */}
                <Col lg={6} className="m-b--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.createdAt)
                    )}
                    message={model.errors?.createdAt}
                  >
                    <InputText
                      label={translate("emailRemindConfig.createdAt")}
                      type={0}
                      value={model.createdAt ? formatDate(model.createdAt) : ""}
                      placeHolder={translate(
                        "emailRemindConfig.placeholder.createdAt"
                      )}
                      className={"tio-account_square_outlined"}
                      disabled
                    />
                  </FormItem>
                </Col>

                {/* Người cập nhật */}
                <Col lg={6} className="m-b--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.updatedBy)
                    )}
                    message={model.errors?.updatedBy}
                  >
                    <InputText
                      label={translate("emailRemindConfig.updatedBy")}
                      type={0}
                      value={model.updatedBy?.name}
                      className={"tio-account_square_outlined"}
                      disabled
                    />
                  </FormItem>
                </Col>

                {/* Ngày cập nhật */}
                <Col lg={6} className="m-b--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.updatedAt)
                    )}
                    message={model.errors?.updatedAt}
                  >
                    <InputText
                      label={translate("emailRemindConfig.updatedAt")}
                      type={0}
                      value={model.updatedAt ? formatDate(model.updatedAt) : ""}
                      className={"tio-account_square_outlined"}
                      disabled
                    />
                  </FormItem>
                </Col>
              </Row>
            )}
          </Row>

          <div className="page-detail__title p-t--md">
            {translate("emailRemindConfig.calendarReminder")}
          </div>

          <div className="permission-role-detai_content_table">
            <div className="page page-master m-b--lg m-t--sm">
              <div className="page-master__content">
                <div className="d-flex justify-content-end">
                  <Button
                    type="secondary"
                    className="btn--lg btn-orange-export pb-2"
                    icon={<Add16 />}
                    onClick={handleAddRow}
                  >
                    {translate("general.actions.create")}
                  </Button>
                </div>
              </div>
              <div className="page-master__content-table">
                <StandardTable
                  className={
                    utilService.getValidateStatus(
                      model,
                      nameof(model.emailReminderSchedules)
                    )
                      ? "m-b--md"
                      : ""
                  }
                  rowKey={"id"}
                  columns={emailRemindConfigMappingColumns}
                  dataSource={listEmailReminderSchedules}
                  isDragable={true}
                  tableSize={"md"}
                  scroll={{ x: 1000 }}
                />
                {(!listEmailReminderSchedules ||
                  listEmailReminderSchedules.length === 0) && (
                  <div className="row-error">
                    <span className="text-error">
                      {model?.errors?.emailReminderSchedules}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default EmailRemindConfigDetail;
